import React from "react";
import { Link } from "react-router-dom";
import { Dumbbell, ArrowLeft } from "lucide-react";
import { TEAL_BAND } from "./layout/PageShell";
import { scrollWindowToTop } from "../lib/scrollTop";

export default function LegalShell({ title, kicker, effective, children }) {
  React.useLayoutEffect(() => {
    if (!window.location.hash) scrollWindowToTop();
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#2A2623]" data-testid={`legal-page-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      {/* Top bar */}
      <header className="border-b tm-divider">
        <div className="max-w-4xl mx-auto px-6 sm:px-10 py-5 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group" data-testid="legal-home-link">
            <div className="w-9 h-9 rounded-md bg-[var(--logo)] flex items-center justify-center">
              <Dumbbell className="w-5 h-5 text-[var(--logo-fg)]" strokeWidth={2.5} />
            </div>
            <div>
              <div className="font-display text-xl font-black uppercase tracking-tight group-hover:text-[#0F6B6B] transition-colors">TrainMate</div>
              <div className="text-[9px] tracking-[0.3em] uppercase text-[#6B635C]">AU Edition</div>
            </div>
          </Link>
          <Link
            to="/login"
            className="text-xs uppercase tracking-widest text-[#6B635C] hover:text-[#0F6B6B] transition-colors flex items-center gap-1.5"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="w-3 h-3" /> Back
          </Link>
        </div>
      </header>

      {/* Teal title band — look echoes the signed-in app */}
      <div className="text-white" style={{ background: TEAL_BAND }}>
        <div className="max-w-4xl mx-auto px-6 sm:px-10 py-12 sm:py-16">
          {kicker && (
            <p className="text-[10px] uppercase tracking-[0.4em] text-[#D3E8E6] font-semibold mb-4">{kicker}</p>
          )}
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95]">{title}</h1>
          {effective && (
            <p className="mt-6 text-xs uppercase tracking-widest text-[#D3E8E6]" data-testid="legal-effective-date">
              Effective {effective}
            </p>
          )}
        </div>
      </div>

      {/* Body */}
      <main className="max-w-4xl mx-auto px-6 sm:px-10 py-12 sm:py-16">
        <div className="space-y-8 text-[#2A2623] leading-relaxed text-[15px]">
          {children}
        </div>

        <footer className="mt-20 pt-8 border-t tm-divider text-xs text-[#6B635C] flex flex-wrap gap-x-6 gap-y-2">
          <Link to="/privacy" className="hover:text-[#0F6B6B] transition-colors" data-testid="footer-privacy">Privacy</Link>
          <Link to="/terms" className="hover:text-[#0F6B6B] transition-colors" data-testid="footer-terms">Terms</Link>
          <Link to="/data-deletion" className="hover:text-[#0F6B6B] transition-colors" data-testid="footer-data-deletion">Data deletion</Link>
          <span className="ml-auto">© {new Date().getFullYear()} TrainMate · Australia</span>
        </footer>
      </main>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section className="space-y-3">
      <h2 className="font-display text-xl sm:text-2xl font-bold uppercase text-[#2A2623] tracking-wide">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
